import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "antd";

import { isAuthenticated } from "../data/storage";
import { operationNames, userHasAccess } from "../data/pages";
import ForbiddenPage from "./ForbiddenPage";
import Navbar from "./Navbar";
import Home from "./Home";
import PrescriptionView from "./PrescriptionView";
import Users from "./UsersView/Users";
import Products from "./Products";
import Places from "./Places";
import Cities from "./CitiesView";
import UserRegistration from "./UserRegistration";
import UserLogin from "./UserLogin";
import PrescriptionPage from "./PrescriptionPage";
import MediatorScores from "./mediators/MediatorScores";
import ProductChange from "./ProductUsageChange";
import MediatorsView from "./mediators/MediatorsView";
import CreatePrescription from "./CreatePrescription";
import PrescriptionLogsView from "./PrescriptionLogsView";
import NotFound from "./NotFound";

const { Content } = Layout;

const Main = () => {
    const renderProtected = (path: string, Element: React.ComponentType<any>, operationName: string) => {
        const isAuth = isAuthenticated();
        if (!isAuth) {
            return <Route path={path} element={<Navigate to="/login" />} />
        }
        return <Route
            path={path}
            element={userHasAccess(operationName) ? <Element /> : <ForbiddenPage />}
        />
    };

    const renderPublic = (path: string, Element: React.ComponentType<any>) => {
        const isAuth = isAuthenticated();
        if (isAuth) {
            return <Route path={path} element={<Navigate to="/" />} />
        }
        return <Route
            path={path}
            element={<Element />}
        />
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Navbar />
            <Content style={{ padding: '24px 0' }}>
                <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
                    <Routes>
                        {renderProtected("/", Home, operationNames.VIEW_STATISTICS)}
                        {renderProtected("/prescriptions", PrescriptionView, operationNames.VIEW_PRESCRIPTIONS)}
                        {renderProtected("/prescriptions/:id", PrescriptionPage, operationNames.VIEW_PRESCRIPTIONS)}
                        {renderProtected("/create-prescription", CreatePrescription, operationNames.CREATE_PRESCRIPTION)}
                        {renderProtected("/product-usage-change", ProductChange, operationNames.PRODUCT_USAGE_CHANGE_VIEW)}
                        {renderProtected("/prescription-logs", PrescriptionLogsView, operationNames.VIEW_PRESCRIPTION_LOGS)}
                        {renderProtected("/users", Users, operationNames.VIEW_USERS)}
                        {renderProtected("/products", Products, operationNames.VIEW_PRODUCTS)}
                        {renderProtected("/places", Places, operationNames.VIEW_PLACES)}
                        {renderProtected("/cities", Cities, operationNames.VIEW_CITIES)}
                        {renderProtected("/sign-up", UserRegistration, operationNames.CREATE_USER)}
                        {renderProtected("/mediators", MediatorsView, operationNames.VIEW_MEDIATORS)}
                        {renderProtected("/mediators/scores", MediatorScores, operationNames.VIEW_MEDIATORS)}
                        {renderPublic("/login", UserLogin)}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
            </Content>
        </Layout>
    );
}

export default Main;